<form [formGroup]="mainForm" class="margin-top-10 padding-bottom-50">
  <div class="p-grid p-fluid">
    <div class="col-md-4 col-sm-2 col-xs-12 margin-top-10">
      <label>Name<sup class="req">*</sup></label>
      <input formControlName="name" pInputText type="text">
      <!--        <p-datepicker [(ngModel)]="tempWorkMonthDate" appendTo="body" placeholder="mm/yyyy" view="month" dateFormat="mm/yy" [showIcon]="true" yearRange="1950:2030" [ngModelOptions]="{standalone: true}"></p-datepicker>-->
    </div>
    <div class="col-md-4 col-sm-2 col-xs-12 margin-top-10">
      <label>Email<sup class="req">*</sup></label>
      <input formControlName="email" pInputText type="text">
    </div>
    <div class="col-md-4 col-sm-12 col-xs-12  margin-top-10">
      <label>Phone </label>
      <p-inputmask [className]="'form-input no-border'" formControlName="phone" mask="(999) 999-9999"
                   tabindex="0" unmask="true"></p-inputmask>
    </div>
    <div class="col-md-12 col-sm-2 col-xs-12 margin-top-10">
      <label>Subject<sup class="req">*</sup></label>
      <input formControlName="subject" pInputText type="text">
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 input-container p-button-auto-width image-uploader">
      <p>*Files must be 30 MB or less in size. If necessary, change the name of your files appropriately prior to uploading them. Upload one file at a time.</p>
      <p-fileUpload #fileUploader (onClear)="clearUpload()" (onSelect)="onUpload($event)" [multiple]="true"
                    [showUploadButton]="false" accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.ppt,.pptx" maxFileSize="31457280" name="uploadedFiles[]">
        <!--        <ng-template let-file pTemplate='file' let-clearCallback="clearCallback">-->
        <!--          <div>-->
        <!--&lt;!&ndash;            {{file.name}} - ({{file.size}} bytes)&ndash;&gt;-->
        <!--          </div>-->
        <!--        </ng-template>-->
      </p-fileUpload>
    </div>
    @if (showProgress) {
      <div class="col-md-12 col-sm-12 col-xs-12">
        <p-progressbar mode="indeterminate"></p-progressbar>
      </div>
    }
    <!--    @for (file of freshDeskData?.attachments; track file;  let i = $index) {-->
    <!--      <div class="col-md-3 col-sm-3 col-sm-4 relative">-->
    <!--        <div class="close-button" (click)="deleteImage(i)"><i class="fas fa-times-circle pointer"></i></div>-->
    <!--        <div [ngStyle]="{'background-image': 'url(' + file.attachment_url + ')', 'height': '100px', 'overflow': 'hidden', 'width': '100%'}"></div>-->
    <!--      </div>-->
    <!--    }-->
    <div class="col-md-12 col-sm-2 col-xs-12 margin-top-10">
      <label>Description<sup class="req">*</sup></label>
      <textarea formControlName="description" pInputTextarea rows="8" type="text"></textarea>
    </div>
    <div class="col-md-12 text-align-right margin-top-10">
      <div class="action-buttons float-right form-buttons text-align-right">
        <p-button (click)="cancel()" [className]="'inline-button'" class="p-button-info p-mr-2" icon="pi pi-times" label="Cancel"
                  pTooltip="Cancel"
                  tooltipPosition="bottom"></p-button>
        @if (!isSaving) {
          <p-button (click)="processData()" [className]="'inline-button'" [disabled]="mainForm.invalid || !mainForm.dirty" class="p-button-info p-mr-2" icon="pi pi-save"
                    label="Save"
                    pTooltip="Save"
                    tooltipPosition="bottom"></p-button>
        }
        @if (isSaving) {
          <p-button [className]="'inline-button'" [disabled]="true" class="p-button-info p-mr-2" label="Save">
            <i class="pi pi-spin pi-spinner save-spinner"></i>
          </p-button>
        }
      </div>
    </div>
  </div>
</form>
